import React from 'react';
import { getSrcSet } from '../../../../DeviationViews/Dumbo/Image/_helpers';
import cleanLinkSrc from '../../../../utils/xss/cleanLinkSrc';
var Img = function (props) {
    var file = props.file, deviation = props.deviation, imgStyles = props.imgStyles;
    return (React.createElement("img", { src: cleanLinkSrc(file.src), srcSet: getSrcSet(deviation), alt: deviation.title, style: imgStyles }));
};
Img.displayName = 'Img';
export default Img;
//# sourceMappingURL=ImageBase.js.map